import React, { ComponentType } from 'react';
import {Stack, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
export const LoadingPage: ComponentType = () => {
  return (
    <>
      <Stack
        width={'100%'}
        height={'100%'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Typography>
          <CircularProgress />
        </Typography>
      </Stack>
    </>
  );
};
